import { useEffect, useContext } from 'react';
import history from 'routing/history';
import useWindowSize from 'hooks/useWindowSize';
import { SCREEN_SIZES } from 'style';
import ParallaxContext from './context';

const ParallaxEnabler = () => {
  const { enable, disable } = useContext(ParallaxContext);
  const { width } = useWindowSize();

  useEffect(() => {
    if (width > SCREEN_SIZES.desktop) {
      enable();
    } else {
      disable();
    }
  }, [width, enable, disable]);

  useEffect(() => {
    history.listen(() => {
      disable();
    });
  }, [disable]);

  return null;
};

export default ParallaxEnabler;
